import { type BuyPrizeCodesType, type IUser } from "@jti/rest-api-types";

export enum Status {
  IDLE = "idle",
  PENDING = "pending",
  COMPLETED = "completed",
  FAILED = "failed",
}

export type UserAuthenticationPayload = {
  uuid: string;
  ciam_token: string;
};
export type IUserWithUUID = IUser & { uuid: string };

export type ReferreeType = {
  createdAccount: boolean;
  completedFirstOrder: boolean;
};

export type ReferreeStatsType = {
  earned_points: number;
  referees_count: number;
  completed_first_order_count: number;
};

export type HistoryPointsItemType = {
  date: string;
  event: string;
  points: number;
  balance: number;
  type: string;
  order_id: string | null;
  coupon?: string;
  coupon_type?: BuyPrizeCodesType;
  coupon_pin?: string | null;
  is_added?: boolean;
  issued_reward_status?: string | null;
};

export type HistoryPointsType = {
  items: HistoryPointsItemType[];
  total: number;
  isLoaded: boolean;
  message?: string;
  statusCode: number;
};

export type HistoryReferralItem = {
  date: string;
  event: string;
  points: number;
};

export type HistoryReferral = {
  items: HistoryReferralItem[];
  total: number;
  isLoaded: boolean;
};

export type Points = {
  balance: number;
  status: Status;
  expire_at: string;
  points_to_expire: number;
};

export type TierData = {
  name: string;
  image_url: string;
  next_tier_name: string;
  points_to_next_tier: number;
  current_tier_assignment_date: string;
  cumulative_points: number;
  points_to_maintain_current_tier: number;
  current_tier_secured_till: string;
};

export type LoyaltyReminderState = {
  hasFirstPurchase: boolean;
  parentCodeExists: boolean;
};

export type LoyaltyCoreReducerType = {
  name: string;
  uuid: string;
  surname: string;
  points: Points;
  rewards: number;
  ciamToken: string;
  tier: TierData;
  code: string;
  referrees: ReferreeType[];
  referralStats: ReferreeStatsType;
  historyPoints: HistoryPointsType;
  historyReferral: HistoryReferral;
  isLoaded: boolean;
  isLogged: boolean;
  isRestricted: boolean;
  isReferralOn: boolean;
  isUserDataFetching: boolean;
  reminder: LoyaltyReminderState;
};
